// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"styles_sidebar__1RPyn","active":"styles_active__1cJVI","slideIn":"styles_slideIn__27cpZ"};